(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-full-width-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var overlay = root.querySelector('[data-pfd-overlay]');
      var drawer = root.querySelector('[data-pfd-drawer]');
      var body = root.querySelector('[data-pfd-body]');
      var title = root.querySelector('[data-pfd-title]');
      var closeBtn = root.querySelector('[data-pfd-close]');
      if (!overlay || !drawer || !body || !closeBtn) return;

      var activeSource = null;
      var activeSourceHome = null;
      var activeTrigger = null;

      function close() {
        // Clear any active/selected trigger state
        root.querySelectorAll('[data-pfd-open]').forEach(function (btn) {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-expanded', 'false');
        });

        if (activeSource && activeSourceHome) {
          activeSource.setAttribute('hidden', '');
          activeSourceHome.appendChild(activeSource);
        }
        activeSource = null;
        activeSourceHome = null;

        drawer.setAttribute('aria-hidden', 'true');
        overlay.setAttribute('aria-hidden', 'true');
        drawer.classList.remove('is-open');
        overlay.classList.remove('is-open');
        document.documentElement.classList.remove('pfd-scroll-lock');

        if (activeTrigger) {
          activeTrigger.focus();
          activeTrigger = null;
        }
      }

      function open(trigger) {
        var contentId = trigger.getAttribute('data-pfd-content');
        if (!contentId) return;
        var source = root.querySelector('#' + CSS.escape(contentId));
        if (!source) return;

        root.querySelectorAll('[data-pfd-open]').forEach(function (btn) {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-expanded', 'false');
        });
        trigger.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');

        // Reset existing content
        if (activeSource && activeSource !== source) {
          activeSource.setAttribute('hidden', '');
          if (activeSourceHome) activeSourceHome.appendChild(activeSource);
        }
        activeSource = source;
        activeSourceHome = trigger.closest('.product-block')?.querySelector('.pfd-sources') || null;
        activeTrigger = trigger;

        // Set title
        if (title) title.textContent = trigger.textContent.trim();

        // Move the source node into drawer so forms keep behavior
        source.removeAttribute('hidden');
        body.innerHTML = '';
        body.appendChild(source);

        drawer.setAttribute('aria-hidden', 'false');
        overlay.setAttribute('aria-hidden', 'false');
        // Ensure transitions run
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
          overlay.classList.add('is-open');
        });
        document.documentElement.classList.add('pfd-scroll-lock');

        closeBtn.focus();
      }

      root.addEventListener('click', function (e) {
        var t = e.target;
        if (!(t instanceof Element)) return;

        var opener = t.closest('[data-pfd-open]');
        if (opener) {
          e.preventDefault();
          open(opener);
          return;
        }

        if (t.closest('[data-pfd-close]') || t.closest('[data-pfd-overlay]')) {
          e.preventDefault();
          close();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (drawer.getAttribute('aria-hidden') === 'true') return;
        close();
      });
    }

    document.querySelectorAll('[data-product-full-width-drawer]').forEach(function (root) {
      init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
